import Flickity from 'flickity';

class Carousel {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.setInitialParams();
    this.initCarousels();
  }

  unmount() {
    this.carousels.forEach((carousel) => {
      carousel.destroy();
    });
    this.carousels = [];
  }

  setInitialParams() {
    this.carousels = [];
  }

  initCarousels() {
    this.checkTypeCarousel(this.element);
  }

  checkTypeCarousel($carousel) {
    const c1 = $carousel.getAttribute('data-type') === 'default';
    const c2 = $carousel.getAttribute('data-type') === 'highlight';

    if (c1) {
      this.initCarouselDefault($carousel);
    } else if (c2 && window.matchMedia('(max-width: 1023px)').matches) {
      this.initCarouselHighlight($carousel);
    }
  }

  initCarouselDefault($carousel) {
    const parent = $carousel.closest('[data-ref="carousel-parent"]');
    const carouselIndex = parent.querySelector('[data-ref="carousel-index"]');
    const carouselIndexItems = [
      ...parent.querySelectorAll('[data-ref="carousel-index"]'),
    ];
    const previousButton = parent.querySelector(
      '[data-ref="carousel-previous"]'
    );
    const nextButton = parent.querySelector('[data-ref="carousel-next"]');
    const inc = 20;
    let translate = 0;
    const isNotDraggable = $carousel.hasAttribute('data-no-dragging');

    const currentCarousel = new Flickity($carousel, {
      groupCells: 1,
      cellAlign: 'left',
      prevNextButtons: false,
      draggable: isNotDraggable ? false : true,
      pageDots: false,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            groupCells: this.slides > 10 ? 4 : 1,
          },
        },
      ],
    });

    previousButton.addEventListener('click', () => currentCarousel.previous());
    nextButton.addEventListener('click', () => currentCarousel.next());

    let previousIndex = currentCarousel.selectedIndex;
    currentCarousel.on('change', (index) => {
      const indexNotZeroBased = index + 1;
      const delta = index - previousIndex;

      carouselIndexItems.forEach((item) => {
        item.classList.remove('is-active');
      });
      translate += delta * inc;
      if (carouselIndex) {
        carouselIndex.style.transform = `translate3d(${
          translate == 0 ? translate : -translate
        }px, 0, 0)`;
        carouselIndex
          .querySelector(`[data-count="${indexNotZeroBased}"]`)
          .classList.add('is-active');
      }
      previousIndex = index;

      // add disbaled button class when needed
      if (indexNotZeroBased == 1) {
        previousButton.classList.add('carousel__button--disabled');
        nextButton.classList.remove('carousel__button--disabled');
      }
      if (indexNotZeroBased == currentCarousel.slides.length) {
        nextButton.classList.add('carousel__button--disabled');
        previousButton.classList.remove('carousel__button--disabled');
      }

      if (
        indexNotZeroBased > 1 &&
        indexNotZeroBased < currentCarousel.slides.length
      ) {
        previousButton.classList.remove('carousel__button--disabled');
        nextButton.classList.remove('carousel__button--disabled');
      }
    });

    this.carousels.push(currentCarousel);
  }

  initCarouselHighlight($carousel) {
    const currentCarousel = new Flickity($carousel, {
      groupCells: 1,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
    });

    this.carousels.push(currentCarousel);
  }
}

export default Carousel;
